export default __webpack_public_path__ + "static/media/members_blue.fc527b59.svg";